import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "./language.styles";
import languageSvg from '../../assets/icons/language-svg.svg'

const Language = ()=>{
	const navigate = useNavigate();
	const location = useLocation();

	const isRu = location.pathname.startsWith("/ru");
	const [languageState, setLanguageState] = useState(isRu ? "russian" : "romanian");

	useEffect(() => {
		setLanguageState(isRu ? "russian" : "romanian");
	}, [isRu]);

	const onChangeLanguageHandler = (e)=>{
		const selectedLanguage = e.target.value;
		const targetPath = selectedLanguage === 'romanian' ? '/' : '/ru';
		// react-router's location.hash can be stale here: section nav writes the
		// hash via raw history.replaceState (see navigation.component.jsx), which
		// the router never observes. Read the live browser hash instead.
		const currentHash = window.location.hash || "";
		navigate(`${targetPath}${currentHash}`);
	}
	return(
		<Container>
		<img src={languageSvg} alt="" />
			<select name="language"  id="language" value={languageState} onChange={onChangeLanguageHandler}>
				<option value="romanian" >Ro</option>
				<option  value="russian" >Ru</option>
			</select>
		</Container>
	)
}

export default Language;